<div class="page-header">
    <h2 class="page-title">
        <i class="fa-solid fa-clipboard-check"></i>
        {{ 'ReviewIndicatorsOutcomesProofs' | navTitle | async }}
    </h2>
    <button class="exit-btn" (click)="goBack()" pTooltip="{{'back'|translate}}" tooltipPosition="left">
        @if(dir=='rtl'){
        <i class="fa-solid fa-arrow-right"></i>
        }@else{
        <i class="fa-solid fa-arrow-left"></i>
        }
        <span>{{'back'|translate}}</span>
    </button>
</div>

<!-- Filters Section -->
<div class="filters-container">
    <div class="filter-row">
        <!-- Strategy Dropdown -->
        <div class="filter-section">
            <label class="filter-label">
                <i class="fa-solid fa-bullseye"></i>
                {{'strategy'|translate}}
            </label>
            <div class="strategy-dropdown-wrapper">
                <p-dropdown 
                    [(ngModel)]="selectedStrategyId"
                    [options]="strategyOptions" 
                    optionLabel="name" 
                    optionValue="strategyId" 
                    placeholder="{{'select_strategy'|translate}}"
                    (onChange)="strategyOptionsChange()"
                    styleClass="modern-dropdown">
                </p-dropdown>
            </div>
        </div>
        
        <!-- Search Input -->
        <div class="filter-section">
            <label class="filter-label">
                <i class="fa-solid fa-magnifying-glass"></i>
                {{'search'|translate}}
            </label>
            <div class="search-input-wrapper">
                <i class="fa-solid fa-magnifying-glass search-icon"></i>
                <input 
                    type="text" 
                    pInputText 
                    class="modern-search-input"
                    placeholder="{{'search_by_name'|translate}}"
                    [(ngModel)]="searchText"
                    (ngModelChange)="filterIndicators()">
            </div>
        </div>
    </div>
</div>

<div class="table-container">

    <p-table #table [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]" [class]="dir"
        [value]="filteredIndicators" dataKey="id" [tableStyle]="{ 'width': '100%' }" styleClass="modern-assessment-table"
        (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)">

        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5rem">
                    <i class="fa-solid fa-chevron-down"></i>
                </th>
                <th>
                    <i class="fa-solid fa-bullseye"></i>
                    {{'name'|translate}}
                </th>
                <th>
                    <i class="fa-solid fa-user-tie"></i>
                    {{'responsible'|translate}}
                </th>
                <th>
                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    {{'actions'|translate}}
                </th>
            </tr>

        </ng-template>



        <ng-template pTemplate="body" let-indicator let-expanded="expanded">
            <tr class="cursor-pointer" (click)="expanded ? table.toggleRow(indicator) : table.toggleRow(indicator)">
                <td>
                    <div>
                        <p-button (onClick)="expanded ? table.toggleRow(indicator) : table.toggleRow(indicator)"
                            type="button" pRipple [pRowToggler]="indicator" [text]="true" [rounded]="true" [plain]="true"
                            [icon]="expanded ? 'pi pi-chevron-up':'pi pi-chevron-down'" />
                    </div>
                </td>
                <td class="font-bold">
                    {{ indicator.name }}
                </td>
                <td class="responsible-cell">
                    <span class="responsible-badge">{{indicator.in_charge_name || 'غير محدد'}}</span>
                </td>
                <td>
                    <a [routerLink]="['/strategies',selectedStrategyId,'indicators',indicator.id]">
                        <p-button [text]="true" [plain]="true" pTooltip='{{"go_to_indicator" | translate}}' routerLinkActive="router-link-active">
                            @if(dir=='rtl'){
                            <i class="fa-solid fa-arrow-up-right-from-square fa-flip-horizontal"></i>
                            }@else{
                            <i class="fa-solid fa-arrow-up-right-from-square"></i>
                            }
                        </p-button>
                    </a>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-indicator>
            <tr>
                <td colspan="7">
                    <div class="p-3">
                        <p-table [value]="indicator.files" dataKey="id" styleClass="nested-files-table">
                            <ng-template pTemplate="header">
            <tr>
                <th>
                    <i class="fa-solid fa-file"></i>
                    {{'name'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-note-sticky"></i>
                    {{'notes'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-calendar-days"></i>
                    {{'cycle'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-check-circle"></i>
                    {{'proof_status'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-eye"></i>
                    {{'view'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-download"></i>
                    {{'download'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-list-check"></i>
                    {{'assess'|translate}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file>
            <tr>
                <td class="font-semibold">
                    <i class="{{getFileIcon(file.file_type)}}"></i>
                    <div class="white-space-nowrap overflow-hidden">
                        {{ file.file_name }}
                    </div>
                </td>
                <td>
                    {{file.comments}}
                </td>
                <td class="text-center">
                    {{ file.subEntityName }}
                </td>

                <td class="text-center">
                    <div class="mr-3">
                        @if(dir=='rtl'){
                        @if(file.status=='approved'){
                        <p-tag severity="success" value="معتمد" />
                        }
                        @if(file.status=='rejected'){
                        <p-tag severity="danger" value="مرفوض" />
                        }
                        @if(file.status=='pending'){
                        <p-tag severity="warning" value="قيد المراجعة" />
                        }
                        }@else{
                        @if(file.status=='approved'){
                        <p-tag severity="success" value="{{file.status}}" />
                        }
                        @if(file.status=='rejected'){
                        <p-tag severity="danger" value="{{file.status}}" />
                        }
                        @if(file.status=='pending'){
                        <p-tag severity="warning" value="{{file.status}}" />
                        }
                        }
                    </div>
                </td>
                <td class="text-center">
                    <div class="table-action-icon cursor-pointer" (click)="openFileViewer(file)"
                        pTooltip="{{'view'|translate}}" tooltipPosition="top">
                        <i class="fa-solid fa-eye"></i>
                    </div>
                </td>
                <td class="text-center">
                    <div class="table-action-icon cursor-pointer" (click)="downloadFile(file)"
                        pTooltip="{{'download'|translate}}" tooltipPosition="top">
                        <i class="fa-solid fa-download"></i>
                    </div>
                </td>
                <td class="text-center">
                    <div class="table-action-icon cursor-pointer" (click)="openAssessmentModal(file)"
                        pTooltip="{{'output_assessment'|translate}}" tooltipPosition="top">
                        <i class="fa-solid fa-list-check"></i>
                    </div>
                </td>

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-c>
            <tr>
                <td class="text-center font-bold text-lg text-red-500" [attr.colspan]="9">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    {{'no_data_found' | translate}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
</td>
</tr>
</ng-template>
</p-table>
</div>


@if(assessmentModal)
{
<div class="relative">
    <div class="g-modal ">
        <div class="flex  justify-content-between align-items-center flex-row-reverse ">
            <div (click)="closeAssessmentModal()"
                class=" bg-red-500 g-c-white  cursor-pointer  w-3rem p-1 shadow-4 text-center  font-bold text-xl  bg-secondary-color border-round">
                <i class="fa-solid fa-xmark"></i>
            </div>
            <div class="titel font-bold text-primary-color   g-c-primaryDarkerColor">
                {{'review_proof'|translate}}
            </div>

        </div>
        <div class="br"></div>
        <div class="modal__body">
            <form #assessmentForm="ngForm" (ngSubmit)="assessOutput()">
                <div class="mb-3  flex flex-column gap-2">
                    <div class="flex gap-2">
                        <div class="w-2 g-c-primaryDarkColor"> {{'indicator'|translate}}</div>
                        <span>:</span>
                        <div>{{selectedFile.parentEntityName}}</div>
                    </div>
                </div>
                <div class="mb-3  flex flex-column gap-2">
                    <div class="flex gap-2">
                        <div class="w-2 g-c-primaryDarkColor">{{'cycle'|translate}}</div>
                        <span>:</span>
                        <div>{{selectedFile.subEntityName}}</div>
                    </div>
                </div>
                <div class="mb-3  flex flex-column gap-2">
                    <div class="flex gap-2">
                        <div class="w-2 g-c-primaryDarkColor">{{'proof'|translate}}</div>
                        <span>:</span>
                        <div>{{selectedFile.file_name}}</div>
                    </div>
                </div>


                <div class="mb-3  flex flex-column gap-2">
                    <div class="flex gap-2">
                        <div class="w-2 g-c-primaryDarkColor">{{'target'|translate}}</div>
                        <span>:</span>
                        <div>{{selectedFile.target}}</div>
                    </div>
                </div>
                <div class="mb-3  flex flex-column gap-2">
                    <div class="flex gap-2">
                        <div class="w-2 g-c-primaryDarkColor">{{'actual'|translate}}</div>
                        <span>:</span>
                        <div>{{selectedFile.actual}}</div>
                    </div>
                </div>
                <div class="mb-3  flex flex-column gap-2">
                    <div class="flex gap-2">
                        <div class="w-2 g-c-primaryDarkColor">{{'proof_status'|translate}}</div>
                        <span>:</span>
                        @if(selectedFile.status=='approved'){
                        <p-tag severity="success" value="{{dir=='rtl'?'معتمد':'Approved'}}" />
                        }
                        @if(selectedFile.status=='rejected'){
                        <p-tag severity="danger" value="{{dir=='rtl'?'مرفوض':'Rejected'}}" />
                        }
                        @if(selectedFile.status=='pending'){
                        <p-tag severity="warning" value="{{dir=='rtl'?'قيد المراجعة':'Pending'}}" />
                        }
                    </div>
                </div>

                <div class="mb-3 g-c-primaryDarkColor flex flex-column gap-2">
                    <label> {{'notes'|translate}}</label>

                    <textarea name="notes" required rows="5" cols="30" pInputTextarea
                        [(ngModel)]="selectedFile.comments"></textarea>
                </div>
                @if (dir=='ltr') {
                <div class="flex flex-wrap gap-3">

                    <label class="font-bold g-c-primaryDarkColor"> {{'proof_status'|translate}}</label>
                    <div class="flex align-items-center">
                        <p-radioButton name="{{MediaFileStatusEnum['approved']}}"
                            value="{{MediaFileStatusEnum['approved']}}" [(ngModel)]="selectedFile.status"
                            inputId="approved" />
                        <label for="approved" class="ml-2 text-green-500">
                            {{MediaFileStatusEnum['approved']}}
                        </label>
                    </div>
                    <div class="flex align-items-center">
                        <p-radioButton name="{{MediaFileStatusEnum['rejected']}}"
                            value="{{MediaFileStatusEnum['rejected']}}" [(ngModel)]="selectedFile.status"
                            inputId="rejected" />
                        <label for="rejected" class="ml-2 text-red-500">
                            {{MediaFileStatusEnum['rejected']}}
                        </label>
                    </div>
                </div>
                }@else {
                <div class="flex flex-wrap gap-3">
                    <label class="font-bold g-c-primaryDarkColor"> {{'proof_status'|translate}}</label>
                    <div class="flex  gap-2  align-items-center">
                        <p-radioButton name="rejected" value="approved" [(ngModel)]="selectedFile.status"
                            inputId="approved" />
                        <label for="approved" class="ml-2 text-green-500">
                            {{FileStatusValues['approved']}}
                        </label>
                    </div>
                    <div class="flex gap-2 align-items-center">
                        <p-radioButton name="rejected" value="rejected" [(ngModel)]="selectedFile.status"
                            inputId="rejected" />

                        <label for="rejected" class="ml-2 text-red-500">
                            {{FileStatusValues['rejected']}}
                        </label>
                    </div>
                </div>
                }

                <div class="flex  gap-3 mt-7 justify-content-center align-items-center">

                    <div class="text-center">
                        <button pButton [disabled]="assessmentForm.invalid" type=" submit">
                            <div class="flex gap-3">
                                <i class="pi pi-check"></i>
                                <span>{{'assess'|translate}}</span>
                            </div>
                        </button>
                    </div>
                    <div class="text-center">
                        <button pButton class="p-button-danger" (click)="closeAssessmentModal()">
                            <div class="flex gap-3">
                                <i class="pi pi-times"></i>
                                <span>{{'cancel'|translate}}</span>
                            </div>
                        </button>
                    </div>
                </div>


            </form>


        </div>
    </div>
    <div class="g-overlay"></div>
</div>
}

@if(isFileViewer){
<p-dialog header="{{selectedFile?.file_name}}" [modal]="true" [(visible)]="isFileViewer" [style]="{ width: '90rem' }"
    [breakpoints]="{ '1199px': '90vw', '575px': '90vw' }" [maximizable]="true">
    <div>
        <web-viewer [fileUrl]="selectedFile"></web-viewer>
    </div>
</p-dialog>

}
